
  import Vue from 'vue'
  import { Component, Prop } from 'vue-property-decorator'
  import { State, Getter, Action, Mutation } from '../store-helper'

  @Component({
  })
  export default class ImportComponent extends Vue {
    @Action loadData
    @Action uploadFile

    constructor () {
      super()
    }

    public created () {
      this.loadData()
    }

    public async handleFileUpload(){
      const loadingIndicator = (<Element>this.$refs.loading_indicator)
      document.body.appendChild(loadingIndicator);
      const input = (<any>this.$refs.file);
      const file = input.files[0];
      await this.uploadFile({ file });
      input.value = "";
      const container = (<Element>this.$refs.loading_indicator_wrapper);
      container.appendChild(loadingIndicator);
    }
  }
